import BaseModel from "@/api/models/BaseModel";

/**
 * BlogPostStatus
 */
export default class BlogPostStatus extends BaseModel{
    
    constructor() {
        super();

        this.ACTIVE = 1;
        this.INACTIVE = 2;
        this.ABOUT_POST = 3;
    }

}